import React, {Component, PropTypes} from "react";

import {shouldRender, setState} from "react-jsonschema-form/lib/utils";


class CommentWidget extends Component {

  constructor(props) {
    super(props);
    const {open, id} = props;
    this.state = {open: open, id: id};
  }

  componentWillReceiveProps(nextProps) {
    this.setState({...nextProps});
  }

  onStateChange = (e) => {
    e.preventDefault();
    this.setState({
      "open": !this.state.open
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shouldRender(this, nextProps, nextState);
  }

  render() {
    const {id, readonly, disabled, autofocus, value, required, onChange} = this.props;
    const open = this.state.open || value;
    return (
      <div id={id} className="comments">
        { open ? <textarea type="text" placeholder="Your comments" className="custom" value={value} required={required} onChange={(event) => this.props.onChange(event.target.value)} /> : null }
        { open ? null : <button className="btn btn-comments" onClick={this.onStateChange}>Your comments</button> }
      </div>
    );
  }
}

CommentWidget.defaultProps = {
  open: false
};

if (process.env.NODE_ENV !== "production") {
  CommentWidget.propTypes = {
    open: PropTypes.bool
  };
}

export default CommentWidget;


// WEBPACK FOOTER //
// ./src/components/CommentWidget.js